import {  ProgressBarContainer } from "./style";
import { ProgressBarProps } from "./types";

export default function ProgressBar({currentStep, totalSteps = 3}:ProgressBarProps) {
  const progress = (currentStep / totalSteps) * 100;
  return (
        <ProgressBarContainer progress={progress}>
          <span>Pergunta {currentStep} de 3</span>
          <div className="progress-total">
            <div className="progress-step"  />
          </div>
        </ProgressBarContainer>
  );
}
